import { createAction, props } from '@ngrx/store';
import { Alert } from '../models/alert.interface';

export const loadAlert = createAction('[Alerts/API] Load Alert');

export const loadedAlert = createAction('[Alerts/API] Loaded Alert Success', props<{ alert: Alert | null }>());

export const updateAlert = createAction('[Alerts/API] Update Alert');
